
import React from "react";
import { i18nManager } from "../../../../i18n";
import * as ReactRouterDom from "react-router-dom";
import { ApiResponseData, BaseService, EarningService, IMember, ITeam, ITeamAnalytics, ITeamMember, ITeamMemberEarning, ITeamTopProgram, ITeamTransaction, SanitizedResponse, TeamRole, TeamService, TransactionFlow } from "../../../../services";
import { Button, ChartData, ChartType, Classname, Column, DateHelper, DateTimeInput, DateTimePickerLayout, DateTimePickerSelectionMode, Dropdown, FormControl, Scheme, StringHelper, Table } from "@rivtn/noseur";
import { Schemes, Utils } from "../../../../utils";
import { Elements } from "../../../shared/Elements";
import { ChartManager } from "../../../shared/ChartManager";
import AnalCard from "../../../shared/analytics/AnalCard";

export interface TeamTransactionsProps {
    profile: IMember;
}

function TeamTransactions(props: TeamTransactionsProps) {

    const { profile } = props;
    const teamService = TeamService.getInstance();
    let { id: teamId = "" } = ReactRouterDom.useParams();
    const analLabels = i18nManager.Labels.teams.analytics;
    const [team, setTeam] = React.useState<ITeam>({} as any);
    const teamAnalyticsChartDataState = React.useState<ChartData>();
    const labels = i18nManager.Labels.teams.analytics.earnings.transactions;
    const [searchParams, setSearchParams] = ReactRouterDom.useSearchParams(window.location.search);
    const [teamTransactions, setTeamTransactions] = React.useState<ApiResponseData<ITeamTransaction>>({});
    const currencySign = i18nManager.getCurrencySign(searchParams.get("curr") ?? "NGN");

    React.useEffect(fetchInformation, []);

    return (<div className="earnings analytics">
        <div className="header">
            <div className="l" style={{ display: "flex", flexDirection: "column" }}>
                <span className="t lined-limit"><i className="fa fa-arrow-left" onClick={() => window.history.back()} />
                    {i18nManager.Labels.teams.title + " - " + teamId + " - " + analLabels.title + " - " + labels.title}</span>
                <span className="lined-limit" style={{ marginLeft: 25, fontWeight: "normal" }}>
                    {team.name}{" "}
                </span>

            </div>
            <div className="queries">
                <Dropdown noIcon scheme={Schemes.OMNEHOST} formControlProps={{ className: "plan-dd", isFieldset: true, label: analLabels.country_currency, }}
                    selectedOptionIndex={(i18nManager.CountriesAndCurrencies?.findIndex((p) => p?.currency_code === (searchParams.get("curr") ?? "NGN")) ?? 0)}
                    textInputProps={{ style: { paddingLeft: 15 } }}
                    options={i18nManager.CountriesAndCurrencies} optionMap={{
                        value: "currency_code",
                        label: "{label} ({currency_name} - {currency_code})",
                    }} onSelectOption={(option) => {
                        Utils.updateSearchParams("curr", option.currency_code, setSearchParams, fetchInformation);
                    }} />
                <FormControl className="date-range-dd" isFieldset scheme={Schemes.OMNEHOST} label={analLabels.date_range} rightContent={"fa fa-calendar"} style={{ width: 360 }}>
                    <DateTimeInput fill leftLayout={DateTimePickerLayout.FINE_LEFT_LAYOUT} formatDate={(date) => Utils.formatToFineDate4(date)}
                        selectedDates={[(searchParams.has("from") ? new Date(searchParams.get("from")!) : DateHelper.getStartOfMonth()), new Date(searchParams.get("to") ?? Utils.formatToApiDate(new Date(), false, false)!)]}
                        selectionMode={DateTimePickerSelectionMode.RANGE} onSelectDate={(options) => {
                            Utils.updateSearchParamses({
                                "to": Utils.formatToApiDate(options.toDate!, false, false),
                                "from": Utils.formatToApiDate(options.fromDate!, false, false),
                            }, setSearchParams, fetchInformation);
                        }} />
                </FormControl>
            </div>
        </div>
        <div style={{ display: "flex", flexDirection: "column", height: "100%" }}>
            <div className="pagination">
                {Elements.buildPaginator(teamTransactions ?? {},
                    ({ currentPage }, size) => Utils.updateSearchParamses({ "page": currentPage, size }, setSearchParams, fetchInformation),
                    parseInt(searchParams.get("page") ?? "1"), { margin: 15, marginBottom: 5 })}
                {Elements.buildSorter(labels.sorts, (sort) => Utils.updateSearchParamses({ sort }, setSearchParams, fetchInformation), labels.sorts[0].label)}
            </div>
            <div style={{ display: "flex", flexDirection: "row", alignItems: "self-end", justifyContent: "space-between" }}>
                {Elements.buildConfirmDialogForm(labels.query_inputs, (name: string, value: any, searching: any) => {

                }, {}, undefined, { flex: 0.8, marginTop: 0, flexDirection: "row", alignItems: "center" }, undefined, {
                    marginRight: 15
                })}
                <Button raised scheme={Schemes.OMNEHOST} text={labels.export} style={{ padding: "10px 25px", marginBottom: 10 }} />
            </div>

            <Table stripedRows scheme={Schemes.OMNEHOST} data={teamTransactions.content} totalRecords={teamTransactions.total_elements} dataRefreshKeys={["external_id", "created_at"]}
                style={{ flex: 1, marginTop: 30 }} rowsPerPage={200} loadingState={Elements.LOADING_STATE} emptyState={Elements.buildEmptyListView("fas fa-sack-dollar", (<span>
                    {labels.empty_label_parts.no_earning_found}{" "}
                    <ReactRouterDom.NavLink to="/tournaments">{labels.empty_label_parts.participate}</ReactRouterDom.NavLink>{" "}
                    {labels.empty_label_parts.in_tournament_or}
                    <ReactRouterDom.NavLink to={`/teams/${teamId}/merch`}>{labels.empty_label_parts.create_merch_store}</ReactRouterDom.NavLink>{" "}
                    {labels.empty_label_parts.to_generate_incomes}
                </span>), { marginTop: 50 })}>
                <Column className="table-c" header={labels.table.headers.date} dataKey="date" template={(v) => Utils.formatToFineDate(v, true)} />
                <Column className="table-c" header={labels.table.headers.flow} dataKey="flow" template={(v: TransactionFlow) => {
                    return (<span style={{ fontWeight: "bold", color: (v === TransactionFlow.IN ? "#20C173" : "#FF7171") }}>{(labels as any)[v.toLowerCase()]}</span>);
                }} />
                <Column className="table-c" header={labels.table.headers.amount} dataKey="amount" template={(v: number) => (`${currencySign} ${StringHelper.toPresentableMoneyValue(v)}`)} />
                <Column className="table-c" header={labels.table.headers.source} template={(v: ITeamTransaction) => {
                    return "TODO";
                    /*let link = EarningService.buildTransactionSourceLink(v);
                    const label = v.source?.label ?? v.source?.extra_data?.name;
                    return (<div style={{ display: "flex", flexDirection: "row", alignItems: "center", }}>
                        {v.source?.extra_data?.logo && (<img alt={label} src={v.source?.extra_data?.logo} style={{ width: 20, height: 20, marginRight: 10, borderRadius: "100%" }} />)}
                        {link ? (<a target="_blank" href={link}>{label}</a>) : (<span>{label}</span>)}
                    </div>);*/
                }} />
                <Column className="table-c" header={labels.table.headers.recipient} template={(v: ITeamTransaction) => ((v.recipient as ITeamMember).display_name)} />
            </Table>
        </div>
    </div>);

    function fetchInformation() {
        teamService.getTeamByPublicId(teamId!).then(({ sanitized }: SanitizedResponse<ITeam>) => {
            setTeam(sanitized);
        }).catch(BaseService.reportError);

        const params = {
            sort: searchParams.get("sort") ?? "",
            page: searchParams.get("page") ?? "1",
            size: searchParams.get("size") ?? "100",
            currency_code: searchParams.get("curr") ?? "NGN",
            to: searchParams.get("to") ?? Utils.formatToApiDate(new Date())!,
            fields: ["earnings.total", "tournaments.entered", "achievements.total"],
            from: searchParams.get("from") ?? Utils.formatToApiDate(DateHelper.getStartOfMonth())!,
        };
        setTeamTransactions({});
        teamService.queryTransactions(teamId, params).then(({ apiResponse }: SanitizedResponse<any>) => {
            setTeamTransactions(apiResponse.data!);
        }).catch(BaseService.reportError);
    }

}

export default TeamTransactions;
